var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 81.2",
    style: {
      enableBackground: "new 0 0 110 81.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.1,6.5C96.6,3.1,92,1.1,87,1.1S77.5,3.1,74,6.5c-3.5,3.5-5.4,8.1-5.4,13.1s1.9,9.6,5.4,13.1c3.5,3.5,8.1,5.4,13.1,5.4 s9.6-1.9,13.1-5.4c3.5-3.5,5.4-8.1,5.4-13.1S103.6,10,100.1,6.5z M101.4,19.6c0,3.8-1.5,7.4-4.2,10.1c-2.7,2.7-6.3,4.2-10.1,4.2 s-7.4-1.5-10.1-4.2c-2.7-2.7-4.2-6.3-4.2-10.1s1.5-7.4,4.2-10.1S83.2,5.3,87,5.3s7.4,1.5,10.1,4.2S101.4,15.8,101.4,19.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94,16.1c-0.3-3.6-3.2-6.4-6.8-6.5l0,0c-1.9,0-3.7,0.7-5.1,2s-2.1,3.2-2.1,5c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7 c0-1,0.4-1.9,1.1-2.6c0.7-0.7,1.7-1.1,2.7-1c1.9,0,3.4,1.5,3.6,3.4c0.1,1.9-1.2,3.6-3.1,3.9c-1.3,0.3-2.3,1.5-2.3,2.8v1.3 c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7v-0.9C92,22.6,94.3,19.5,94,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4,29.9c0,1.1,0.8,1.7,1.7,1.7s1.7-0.6,1.7-1.7C88.7,27.7,85.4,27.7,85.4,29.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.9,987.3c-1.1,0.1-1.9,0.9-1.9,2v26c0,1,0.8,1.9,1.8,2c0.4,0,0.8,0,1.1-0.2l24-13c1-0.5,1.4-1.7,0.8-2.7 c-0.2-0.3-0.5-0.6-0.8-0.8l-24-13C45.7,987.4,45.3,987.3,44.9,987.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,993.9v24.4c0,5.6-4.4,10-10,10H28c-5.6,0-10-4.4-10-10v-32c0-5.6,4.4-10,10-10h37.4c-0.3-1.3-0.5-2.6-0.5-4H28 c-7.7,0-14,6.3-14,14v32c0,7.7,6.3,14,14,14h52c7.7,0,14-6.3,14-14v-25.3C92.8,993.5,91.4,993.8,90,993.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroIcon);
export default __webpack_public_path__ + "static/media/intro-icon.d5d10db5a5fee8fe0a66e962c2f6e85e.svg";
export { ForwardRef as ReactComponent };